import { useState } from 'react'

interface FAQItem {
  question: string
  answer: string
}

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const faqs: FAQItem[] = [
    {
      question: 'What does The Simple actually do?',
      answer:
        'We simplify the complex and automate the simple. We provide decision-ready intelligence powered by AI and Human Insight, so you can lead with clarity, speed, and confidence. Intelligence, anytime, anywhere!',
    },
    {
      question: 'How is The Simple different from a traditional consulting firm?',
      answer:
        "We combine curated advanced analytics, research and custom AI platforms to deliver intelligence that's proactive, forward-looking, and easy to act on. It's next gen consulting, reimagined for the modern enterprise.",
    },
    {
      question: 'What is The Simple Stack?',
      answer:
        "It's our proprietary suite of intelligence platforms, Custom AI, Costs AI, and Negotiation AI, designed to deliver clarity across procurement, strategy, innovation, and investments.",
    },
  ]

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section
      id="faq"
      className="py-24 bg-white border-b border-gray-100 relative overflow-hidden scroll-mt-20"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="flex-grow border-t border-gray-300"></div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 px-6">
              Frequently Asked Questions
            </h3>
            <div className="flex-grow border-t border-gray-300"></div>
          </div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="group border-2 border-gray-300 rounded-xl shadow-md hover:shadow-lg hover:border-gray-400 transition-all overflow-hidden">
              <button
                onClick={() => toggleFAQ(idx)}
                className="flex justify-between items-center w-full p-6 text-left bg-white hover:bg-gray-50 transition-all focus:outline-none"
              >
                <span className="font-bold text-lg text-gray-900">{faq.question}</span>
                <i
                  className={`fa-solid fa-chevron-down text-gray-600 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="p-6 bg-white text-gray-800 leading-relaxed border-t-2 border-gray-200">
                  {faq.answer.includes('hello@thesimpleintel.com') ? (
                    <>
                      {faq.answer.split('hello@thesimpleintel.com')[0]}
                      <a
                        href="mailto:hello@thesimpleintel.com"
                        className="underline text-gray-900 hover:text-blue-600 transition-colors"
                      >
                        hello@thesimpleintel.com
                      </a>
                    </>
                  ) : (
                    faq.answer
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
